export const MINUTE = 'MINUTE';
export const HOUR = 'HOUR';
